// extracted by mini-css-extract-plugin
export default {"image":"ZRJ9Ab2"};